import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './desktop-header.scss';

type DesktopHeaderProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  menu?: React.ReactNode;
  size?: string;
  className?: string;
  removeVerticalSpacing?: boolean;
  removeStartSpacing?: boolean;
};

const DesktopHeader = ({
  left,
  right,
  menu,
  size,
  className,
  removeVerticalSpacing,
  removeStartSpacing,
}: DesktopHeaderProps) => {
  const containerClassName = classNames(styles.container, 'header-background-color');

  const headerClassName = classNames([
    styles.header,
    size === 'medium' ? styles.mediumHeader : undefined,
    size === 'large' ? styles.largeHeader : undefined,
    removeVerticalSpacing ? styles.headerNoSpacing : undefined,
    removeStartSpacing ? styles.headerNoStartSpacing : undefined,
  ]);

  return (
    <div className={classNames([containerClassName, className])} data-hook="desktop-header">
      <div className={classNames([headerClassName])}>
        {left}
        {right}
      </div>
      {menu && <div className={styles.menu}>{menu}</div>}
    </div>
  );
};

DesktopHeader.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  menu: PropTypes.node,
  size: PropTypes.string,
  className: PropTypes.string,
  removeVerticalSpacing: PropTypes.bool,
  removeStartSpacing: PropTypes.bool,
};

export default DesktopHeader;
